import { Stands, type StandsKeys } from '../Stands';
import { type AppHostNames, appHosts } from '../appHosts';

export function getCurrentStand(): StandsKeys {
	const standsKeys: StandsKeys[] = Object.keys(Stands) as StandsKeys[];
	for (const appHost of Object.keys(appHosts) as AppHostNames[]) {
		const stand = standsKeys.find(
			(stand) => appHosts[appHost][stand] === location.origin,
			// ||
			// appConfig[stand].partnersList.includes(location.origin),
		);
		if (stand) {
			return stand;
		}
	}
	return String(process.env.stand) as StandsKeys;
}
